module.exports = __webpack_public_path__ + "static/media/club_thumb2.3b52d31d.jpg";